import { render, staticRenderFns } from "./ongoing-packing.vue?vue&type=template&id=c1966d76"
import script from "./ongoing-packing.vue?vue&type=script&lang=js"
export * from "./ongoing-packing.vue?vue&type=script&lang=js"
import style0 from "./ongoing-packing.vue?vue&type=style&index=0&id=c1966d76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports